export default __webpack_public_path__ + "static/commmune-overseascase-8a782cf439a2ab515be7f09c0a8d2a98.png";